// IMPORTANT: After modifying this file, update CHANGELOG.md with a summary of your changes.
// Add clear comments for non-obvious changes, including what replaced prior behavior, to avoid repeating failed fixes.

import type { BlockConfigOf } from "@/lib/blocks/schemas";

// Key types come off two representative blocks (any light / dark block
// would do) so the public `@/lib/blocks/schemas` surface stays unchanged.
type LightBackground = BlockConfigOf<"checklist">["background"];
type DarkBackground = BlockConfigOf<"pricingTiers">["background"];

// Background enum → Tailwind class, shared by every /rescue-era block
// renderer (review of #102/#103). Before this each block held its own copy
// of the same map. Literal class names so Tailwind's scanner sees them.
export const LIGHT_BG_CLASSES: Record<LightBackground, string> = {
  paper: "bg-opichi-paper",
  white: "bg-white",
  "stone-100": "bg-stone-100",
};

export const DARK_BG_CLASSES: Record<DarkBackground, string> = {
  "stone-900": "bg-stone-900",
  black: "bg-black",
};
